import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import DatePicker from "react-datepicker2";
import moment from 'moment-jalaali';
import axios from 'axios';
import { trackPromise } from "react-promise-tracker";
import Drp_Projects from '../Project/Drp_Projects';
import Drp_Categories from '../Project/Drp_Categories';
import TaskHistory from './TaskHistory';

const TaskProp = forwardRef((props, ref) => {

    //#region const

    const ProjectRef = useRef();
    const CategoryRef = useRef();

    const [Id, setId] = useState(General.GuidEmpty());
    const [Title, setTitle] = useState("");
    const [Description, setDescription] = useState("");
    const [ProjectId, setProjectId] = useState(null);
    const [CategoryId, setCategoryId] = useState(null);
    const [AssignTo, setAssignTo] = useState(null);
    const [Priority, setPriority] = useState(2);
    const [DueDate, setDueDate] = useState(null);
    const [TicketId, setTicketId] = useState(General.GuidEmpty());
    const [States, setStates] = useState([]);
    const [UserList, setUserList] = useState([]);
    const [ShowLoader, setShowLoader] = useState(false);

    const IsAdmin = localStorage.getItem("Permission") === "0";
    const CurrentUserId = localStorage.getItem("UserId");
    //#endregion

    //#region Methods

    useImperativeHandle(ref, () => ({
        ShowEdit(EditId) {
            setId(EditId);
            setTitle("");
            setDescription("");
            setProjectId(null);
            setCategoryId(null);
            //--> کارشناس فقط برای خودش وظیفه ثبت می کند، پس مسئول انجام از قبل مشخص است
            setAssignTo(IsAdmin ? null : CurrentUserId);
            setPriority(2);
            setDueDate(null);
            setTicketId(General.GuidEmpty());
            setStates([]);
            ProjectRef.current.Get();
            if (IsAdmin) {
                BindUsers();
            }
        }
    }))

    const BindUsers = () => {
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/User/GetAll",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setUserList(res.data.map(item => ({
                    label: item.firstName + ' ' + item.lastName,
                    value: item.id
                })));
            })
            .catch(error => {
                General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
            })
    }

    const SelectProject = (value) => {
        setProjectId(value);
        setCategoryId(null);
        CategoryRef.current.Get(value);
    }

    // announce یعنی «ذخیره و اعلام به کارشناس»: وظیفه به جای «ثبت اولیه»
    // با «در انتظار اجرا» ذخیره می شود. سرور هم همین را دوباره بررسی می کند.
    const handleSubmit = (e, announce) => {
        e.preventDefault();
        if (announce && !AssignTo) {
            General.ShowMsg(Enum.MsgType.error, "برای اعلام به کارشناس، ابتدا مسئول انجام را مشخص نمایید");
            return;
        }
        if (Title === "") {
            General.ShowMsg(Enum.MsgType.error, "عنوان وظیفه را وارد نمایید");
            return;
        }
        if (!ProjectId) {
            General.ShowMsg(Enum.MsgType.error, "پروژه را مشخص نمایید");
            return;
        }
        if (!CategoryId) {
            General.ShowMsg(Enum.MsgType.error, "دسته بندی را مشخص نمایید");
            return;
        }
        if (!DueDate) {
            General.ShowMsg(Enum.MsgType.error, "مهلت انجام را مشخص نمایید");
            return;
        }
        setShowLoader(true);
        var RequestOption = {
            method: 'Post',
            url: General.ApiRoute() + '/Task/Save',
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
            data: {
                "Id": Id,
                "Title": Title,
                "Description": Description,
                "ProjectId": ProjectId,
                "CategoryId": CategoryId,
                "AssignTo": AssignTo ? AssignTo : General.GuidEmpty(),
                "Priority": Priority,
                "DueDate": DueDate.format('jYYYY/jMM/jDD'),
                "TicketId": TicketId,
                "Announce": announce ? true : false
            },
            withCredentials: true
        }
        trackPromise(
            axios(RequestOption)
                .then(function (res) {
                    if (res.data.isSuccess) {
                        General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                        setShowLoader(false);
                        props.onSubmit();
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, res.data.error);
                        setShowLoader(false);
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());
                        }
                        else if (error.response.status === 403) {
                            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());
                        }
                        setShowLoader(false);
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                        setShowLoader(false);
                    }
                })
        )
    };

    const BindTask = () => {
        setShowLoader(true);
        var RequestOption = {
            method: 'Get',
            url: General.ApiRoute() + "/Task/GetById",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: Id
            },
            withCredentials: true
        }

        axios(RequestOption)
            .then(function (res) {
                setTitle(res.data.title);
                setDescription(res.data.description);
                setProjectId(res.data.projectId);
                setCategoryId(res.data.categoryId);
                setAssignTo(res.data.assignTo);
                setPriority(res.data.priority);
                setDueDate(moment(res.data.dueDate, 'jYYYY/jMM/jDD'));
                setTicketId(res.data.ticketId);
                setStates(res.data.states);
                CategoryRef.current.Get(res.data.projectId);
                setShowLoader(false);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        General.ShowMsg(Enum.MsgType.error, General.unAuthorize());
                    }
                    else if (error.response.status === 403) {
                        General.ShowMsg(Enum.MsgType.error, General.AccessDenied());
                    }
                    setShowLoader(false);
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoader(false);
                }
            })
    }

    useEffect(() => {
        if (Id !== General.GuidEmpty()) {
            BindTask();
        }
    }, [Id])
    //#endregion

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>عنوان</label>
                <rsuite.Input
                    type="text"
                    value={Title}
                    onChange={value => setTitle(value)}
                    required />
            </div>
            <div className='mt-2'>
                <label>شرح کار</label>
                <rsuite.Input
                    as="textarea"
                    rows={4}
                    value={Description}
                    onChange={value => setDescription(value)} />
            </div>
            <div className='mt-2'>
                <label>پروژه</label>
                <Drp_Projects ref={ProjectRef} value={ProjectId} onSelect={SelectProject} />
            </div>
            <div className='mt-2'>
                <label>دسته بندی</label>
                <Drp_Categories ref={CategoryRef} value={CategoryId} onSelect={value => setCategoryId(value)} />
            </div>
            {
                IsAdmin ?
                    <div className='mt-2'>
                        <label>مسئول انجام</label>
                        <rsuite.SelectPicker
                            data={UserList}
                            value={AssignTo}
                            onChange={value => setAssignTo(value)}
                            onClean={() => setAssignTo(null)}
                            className="w-100"
                            placeholder="فعلا مشخص نیست"
                        />
                    </div>
                    :
                    null
            }
            <div className='mt-2'>
                <label>اولویت</label>
                <rsuite.SelectPicker
                    searchable={false}
                    data={[
                        { label: "پائین", value: 1 },
                        { label: "متوسط", value: 2 },
                        { label: "بالا", value: 3 }
                    ]}
                    value={Priority}
                    onChange={value => setPriority(value)}
                    className="w-100"
                    placeholder="انتخاب کنید"
                />
            </div>
            {/* react-datepicker2 دکمه های تقویمش را بدون type رندر می کند، و یک
                button بدون type داخل form پیش فرضش submit است. برای همین کلیک
                روی تقویم به جای باز کردنش، فرم را ثبت می کرد و پنجره بسته می شد.
                preventDefault فقط همان ثبت شدن را می گیرد؛ هندلرهای خود تقویم
                سر جایشان اجرا می شوند. */}
            <div className='mt-2' >
                <label>مهلت انجام</label>
                <DatePicker className="form-control" isGregorian={false} timePicker={false}
                    value={DueDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                    onChange={(value) => setDueDate(value)} />

                       
            </div>

            <TaskHistory states={States} />

            <rsuite.Divider />
            <div align="left">
                {
                    !ShowLoader ?
                        <>
                            <rsuite.Button appearance="default" className="mt-2"
                                onClick={(e) => handleSubmit(e, false)}>
                                ثبت وظیفه
                            </rsuite.Button>
                            {
                                //--> فقط وقتی مسئول انجام مشخص است، چون اعلام به
                                //--> کسی که تعیین نشده معنا ندارد
                                IsAdmin && AssignTo ?
                                    <rsuite.Button appearance="primary" className="mt-2 ms-2"
                                        onClick={(e) => handleSubmit(e, true)}>
                                        ذخیره و اعلام به کارشناس
                                    </rsuite.Button>
                                    :
                                    null
                            }
                        </>
                        :
                        <rsuite.Button appearance="primary" className="mt-2" disabled>
                            <rsuite.Loader content="در حال ارسال اطلاعات..." />
                        </rsuite.Button>
                }
            </div>
        </form>
    );
});

export default TaskProp;
